export default __webpack_public_path__ + "static/media/text_start_10.f038d32e.png";